/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MusicSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABcUlEQVR4nMWVu0rFQBCGNyjYiugzWPsEqYRTZC4Wy0xAsPFSWqiFhR4tbX0A38LiPITC0UY7FcHOSkEEUdYLZs9JNtkEcWCLhNn/m/3D/jHmv4poZRpYd4FkD1EXmu7LsnwWSQfIchRsBJZTZH3/WcB6BSQHiHY+KM4y/NxDOggDSF6LAB8m58iyY62dKRVnGbrnIKBKHP1TLbcS9wFyjKQPY+Kkh63FiwBjjLHWTsCSLgLrCbI8Imu/k/gooKyqxInyDdMVkFWII8t+aKhGgCxgC5C8dQL0rJ0LeV5n6xjATdRk8tYA52lT8TpAAizrSHqJrC9Aeu1iIUY8CHDX3r9E8eJBALDeFQD9Jh807gTfURA5efJrqzx9BWC1RZsu+yPEzaitxWWqKsYW8G2tB8R6jqy3pQCSm7HmNqmYkWyX/iNIt7xGF8VIetYichNkXQOWC2R9dnuJ8lX33rem15tC1nsHicrzmHKQNE0n/0L8A57kkbKpTIr6AAAAAElFTkSuQmCC)
 */
export const MusicSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.7 2.7a1 1 0 0 0-1.4-1.4l-20 20a1 1 0 1 0 1.4 1.4l20-20ZM15.2 3.78a.5.5 0 0 1 .2.83l-2.28 2.27a.5.5 0 0 1-.52.12L8 5.4v6.4a.5.5 0 0 1-.15.35L2.3 17.7c-.2.2-.5.2-.67 0A2.7 2.7 0 0 1 1 16c0-1.66 1.57-3 3.5-3 .54 0 1.05.1 1.5.29V3.4a2 2 0 0 1 2.65-1.89l6.55 2.27ZM19.15 8.85a.5.5 0 0 0-.15.36v7.08a3.98 3.98 0 0 0-1.5-.29c-1.93 0-3.5 1.34-3.5 3s1.57 3 3.5 3 3.5-1.34 3.5-3V7.6a.25.25 0 0 0-.43-.17l-1.42 1.42Z"
        className={colorClass}
      />
    </svg>
  );
};
